import styled from 'styled-components';

import background from './../../../assets/background/cooperativa.jpg';

export const Container = styled.section`
  overflow: hidden;

  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: scaleX(-1);
    filter: contrast(1.12);
    z-index: -1;
  }

  &:after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      145deg,
      rgba(171, 147, 75, 0.5) 0%,
      rgba(22, 102, 73, 0.2) 65%
    );
    mix-blend-mode: hard-light;
    z-index: -1;
  }
`;

export const Wrapper = styled.div`
  @keyframes fade {
    0% {
      opacity: 0;
      transform: translateX(50px);
    }
  }

  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  position: relative;
  max-width: 1312px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  animation: 0.5s ease 0s 1 normal none running fade;

  > span {
    width: 450px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 2rem;
    background: rgba(22, 102, 73, 0.3);
    border: 1px solid ${props => props.theme.primaryColor};
    padding: 0.8rem;
    border-radius: 3px;
    color: ${props => props.theme.secondaryColor};
    margin-top: 1.5rem;
    user-select: none;
    pointer-events: none;

    @media (max-width: 768px) {
      width: 100%;
    }

    h3 {
      margin-bottom: 1rem;
    }
  }
`;

export const FormContent = styled.div`
  width: 450px;
  border: none;
  border-radius: 4px;
  padding: 1rem 2rem;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    width: 90%;
  }

  figure {
    margin: 1rem;

    img {
      width: 150px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0rem;
  width: 100%;

  > span {
    display: flex;
    align-items: center;
    background: rgba(199, 31, 55, 0.3);
    border: 1px solid ${props => props.theme.error};
    padding: 0.8rem;
    border-radius: 3px;
    color: ${props => props.theme.error};
    margin-top: 1.5rem;
    user-select: none;
    pointer-events: none;

    svg {
      margin-right: 1rem;
      margin-top: -1px;
    }
  }
`;
